// src/slices/companyprice/thunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const getCompanies = createAsyncThunk("company/getAll", async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${API_URL}/company/all`);
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || error.message);
  }
});

export const getCompanyOne = createAsyncThunk("company/getOne", async (id, thunkAPI) => {
  try {
    const response = await axios.get(`${API_URL}/company/one`, { params: { identifier: id } });

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || error.message);
  }
});
